/* DCSBAY — New models banner: optional dismiss, remembered per browser */
(function () {
  'use strict';
  if (window.DcsbayNewModels) return;

  var instances = new WeakMap();

  function storageKey(root) {
    return 'dcsbay:newmodels:' + (root.getAttribute('data-storage-key') || 'default');
  }

  function isDismissed(root) {
    try { return window.localStorage.getItem(storageKey(root)) === '1'; }
    catch (e) { return false; }
  }

  function remember(root) {
    try { window.localStorage.setItem(storageKey(root), '1'); }
    catch (e) { /* private mode: it just comes back next visit */ }
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Banner(root) {
    var self = this;
    this.root = root;
    this.designMode = root.getAttribute('data-design-mode') === 'true';

    // An autoplaying loop is motion: give reduced-motion visitors a paused
    // poster with controls instead.
    var video = root.querySelector('[data-nm-video]');
    if (video && reduced() && video.hasAttribute('autoplay')) {
      video.removeAttribute('autoplay');
      video.setAttribute('controls', '');
      video.pause();
    }

    // In the theme editor the banner must always stay visible.
    if (!this.designMode && isDismissed(root)) root.hidden = true;

    this.onClick = function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!t.closest('[data-nm-close]')) return;
      e.preventDefault();
      remember(root);
      if (!self.designMode) root.hidden = true;
    };
    root.addEventListener('click', this.onClick);
  }

  Banner.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
  };

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dcsbay-newmodels]'), function (root) {
      if (instances.has(root)) return;
      instances.set(root, new Banner(root));
    });
  }

  function destroy(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dcsbay-newmodels]'), function (root) {
      var inst = instances.get(root);
      if (inst) { inst.destroy(); instances.delete(root); }
    });
  }

  window.DcsbayNewModels = { init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
